import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

function EditCleaningListings() {
  const { id } = useParams();
  const navigate = useNavigate();
 

  const [message, setMessage] = useState("");

  // ================================
  // BASIC LOCATION
  // ================================
  const [suburb, setSuburb] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");

  // ================================
  // CLIENT OVERVIEW
  // ================================
  const [accessType, setAccessType] = useState("Access Available Anytime");
  const [streetParking, setStreetParking] = useState(false);
  const [petsAtHome, setPetsAtHome] = useState(false);
  const [alarmCodeRequired, setAlarmCodeRequired] = useState(false);
  const [homeSize, setHomeSize] = useState("");

  // ================================
  // SERVICE PREFERENCES
  // ================================
  const [serviceDay, setServiceDay] = useState("any");
  const [serviceTime, setServiceTime] = useState("any");

  // ================================
  // JOB DETAILS
  // ================================
  const [cleaningTime, setCleaningTime] = useState("");
  const [frequency, setFrequency] = useState("fortnightly");

  // ================================
  // AREAS SERVICED
  // ================================
  const [bedroomsCleaned, setBedroomsCleaned] = useState(1);
  const [bathroomsCleaned, setBathroomsCleaned] = useState(1);
  const [toiletsCleaned, setToiletsCleaned] = useState(1);
  const [kitchenIncluded, setKitchenIncluded] = useState(true);
  const [livingAreasIncluded, setLivingAreasIncluded] = useState(true);
  const [newClient, setNewClient] = useState(false);
  const [longTermClient, setLongTermClient] = useState(false);

  // ================================
  // ROUTINE CLEANING SERVICES (MATCH POST)
  // ================================
  const [services, setServices] = useState({
    dusting: true,
    vacuuming: true,
    mopping: true,
    surfacesWiped: true,
    tidying: true,
    kitchenCleaning: true,
    bathroomCleaning: true,
    bedMaking: false,
    linenChanging: false,
    washing: false,
    ironing: false,
    pantryTidying: false,
    loungeVacuum: false,
    cobwebRemoval: false,
    lightSpotCleaning: false,
    dishwashing: false,
    organisation: false,
  });

  const toggleService = (key) => {
    setServices((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // ================================
  // PRICING (LOCKED)
  // ================================
  
  const [avgJobPrice, setAvgJobPrice] = useState("");
  const [salePrice, setSalePrice] = useState("");

  // ================================
  // LOAD LISTING
  // ================================
  useEffect(() => {
    async function load() {
      try {
        const token = localStorage.getItem("token");
        const user = JSON.parse(localStorage.getItem("user"));

        if (!user?.id) {
          navigate("/my-listings");
          return;
        }

        const res = await fetch(`${API_BASE_URL}/api/cleaning/listings/${id}?user_id=${user.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (!data?.success || !data?.listing) {
          alert("Listing not found");
          navigate("/my-listings");
          return;
        }

        const l = data.listing;

        if (String(l.user_id) !== String(user.id)) {
          alert("You cannot edit this listing.");
          navigate("/my-listings");
          return;
        }

        // PREFILL (LIKE POST FIELDS)
        setSuburb(l.suburb || "");
        setState(l.state || "");
        setPostcode(l.postcode || "");

        setAccessType(l.accessType || "Access Available Anytime");
        setStreetParking(!!l.streetParking);
        setPetsAtHome(!!l.petsAtHome);
        setAlarmCodeRequired(!!l.alarmCodeRequired);
        setHomeSize(l.homeSize || "");

        setServiceDay(l.serviceDay || "any");
        setServiceTime(l.serviceTime || "any");

        setCleaningTime(l.cleaningTime || "");
        setFrequency(l.frequency || "fortnightly");

        setBedroomsCleaned(l.bedroomsCleaned ?? 1);
        setBathroomsCleaned(l.bathroomsCleaned ?? 1);
        setToiletsCleaned(l.toiletsCleaned ?? 1);
        setKitchenIncluded(!!l.kitchenIncluded);
        setLivingAreasIncluded(!!l.livingAreasIncluded);

        setNewClient(!!l.newClient);
        setLongTermClient(!!l.longTermClient);

        // Merge so ALL checkboxes always show
        setServices((prev) => ({ ...prev, ...(l.services || {}) }));

        // LOCKED PRICING (DISPLAY ONLY)
        
        setAvgJobPrice(l.avgJobPrice || "");
        setSalePrice(l.salePrice || "");
      } catch (err) {
        console.error("❌ LOAD EDIT CLEANING ERROR:", err);
        navigate("/my-listings");
      }
    }

    load();
  }, [id, navigate]);

  // ================================
  // SAVE HANDLER (NO PRICE UPDATE)
  // ================================
  const handleSave = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${API_BASE_URL}/api/cleaning/listings/edit/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          suburb,
          state,
          postcode,

          accessType,
          streetParking,
          petsAtHome,
          alarmCodeRequired,
          homeSize,

          serviceDay,
          serviceTime,

          cleaningTime,
          frequency,

          bedroomsCleaned,
          bathroomsCleaned,
          toiletsCleaned,
          kitchenIncluded,
          livingAreasIncluded,
          newClient,
          longTermClient,

          services,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setMessage(data?.error || "❌ Failed to save changes");
        return;
      }

      alert("Cleaning listing updated");
      navigate("/my-listings");
    } catch (err) {
      console.error("❌ SAVE CLEANING ERROR:", err);
      setMessage("❌ Failed to save changes");
    }
  };

  // ================================
  // UI (MATCH POST LAYOUT)
  // ================================
  return (
    <div style={container}>
      <h2 style={pageHeader}>Edit Cleaning Listing</h2>

      {message && (
        <div
          style={{
            marginBottom: "20px",
            textAlign: "center",
            fontWeight: 600,
            color: message.includes("❌") ? "#d32f2f" : "#2e7d32",
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSave} style={form}>
        {/* LOCATION */}
        <h3 style={sectionHeader}>Location</h3>

        <label style={labelBold}>Suburb</label>
        <input style={input} required value={suburb} onChange={(e) => setSuburb(e.target.value)} />

        <label style={labelBold}>State</label>
        <select style={input} required value={state} onChange={(e) => setState(e.target.value)}>
          <option value="">Select</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="NT">NT</option>
          <option value="TAS">TAS</option>
          <option value="ACT">ACT</option>
        </select>

        <label style={labelBold}>Postcode</label>
        <input style={input} required value={postcode} onChange={(e) => setPostcode(e.target.value)} />

        {/* CLIENT OVERVIEW */}
        <h3 style={sectionHeaderBlue}>Client Overview</h3>

        <label style={labelBold}>Access Type</label>
        <select style={input} value={accessType} onChange={(e) => setAccessType(e.target.value)}>
          <option value="Access Available Anytime">Access Available Anytime</option>
          <option value="Access Requires Client to Be Home">Access Requires Client to Be Home</option>
          <option value="Access via Key or Gate Code">Access via Key or Gate Code</option>
        </select>

        <Checkbox label="Street Parking Available" value={streetParking} setValue={setStreetParking} />
        <Checkbox label="Pets at Home" value={petsAtHome} setValue={setPetsAtHome} />
        <Checkbox label="Alarm Code Required" value={alarmCodeRequired} setValue={setAlarmCodeRequired} />

        <label style={labelBold}>Home Size (e.g. 3 Bedroom)</label>
        <input style={input} value={homeSize} onChange={(e) => setHomeSize(e.target.value)} />

        {/* SERVICE PREFERENCES */}
        <h3 style={sectionHeader}>Preferred Service</h3>

        <label style={labelBold}>Preferred Day</label>
        <select style={input} value={serviceDay} onChange={(e) => setServiceDay(e.target.value)}>
          <option value="any">Any</option>
          <option value="monday">Monday</option>
          <option value="tuesday">Tuesday</option>
          <option value="wednesday">Wednesday</option>
          <option value="thursday">Thursday</option>
          <option value="friday">Friday</option>
           <option value="saturday">saturday</option>
          <option value="sunday">sunday</option>
        </select>

        <label style={labelBold}>Preferred Time</label>
        <select style={input} value={serviceTime} onChange={(e) => setServiceTime(e.target.value)}>
          <option value="any">Any</option>
          <option value="am">Morning</option>
          <option value="pm">Afternoon</option>
        </select>

        {/* JOB DETAILS */}
        <h3 style={sectionHeader}>Job Details</h3>

        <label style={labelBold}>Cleaning Time</label>
        <select style={input} required value={cleaningTime} onChange={(e) => setCleaningTime(e.target.value)}>
          <option value="">Choose Time</option>
          <option value="0.5">30 Minutes</option>
          <option value="1">1 Hour</option>
          <option value="1.5">1.5 Hours</option>
          <option value="2">2 Hours</option>
          <option value="3">3 Hours</option>
        </select>

        <label style={labelBold}>Frequency</label>
        <select style={input} value={frequency} onChange={(e) => setFrequency(e.target.value)}>
          <option value="weekly">Weekly</option>
          <option value="fortnightly">Fortnightly</option>
          <option value="monthly">Monthly</option>
        </select>

        {/* AREAS SERVICED */}
        <h3 style={sectionHeader}>Areas Serviced</h3>

        <label style={labelBold}>Bedrooms Cleaned</label>
        <input
          type="number"
          style={input}
          min="1"
          value={bedroomsCleaned}
          onChange={(e) => setBedroomsCleaned(e.target.value)}
        />

        <label style={labelBold}>Bathrooms Cleaned</label>
        <input
          type="number"
          style={input}
          min="1"
          value={bathroomsCleaned}
          onChange={(e) => setBathroomsCleaned(e.target.value)}
        />

        <label style={labelBold}>Toilets Cleaned</label>
        <input
          type="number"
          style={input}
          min="1"
          value={toiletsCleaned}
          onChange={(e) => setToiletsCleaned(e.target.value)}
        />

        <Checkbox label="Kitchen Included" value={kitchenIncluded} setValue={setKitchenIncluded} />
        <Checkbox label="Living Areas Included" value={livingAreasIncluded} setValue={setLivingAreasIncluded} />

        {/* CLIENT HISTORY */}
<h3 style={sectionHeader}>Client History</h3>

<label style={checkboxRow}>
  <input
    type="checkbox"
    checked={newClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setNewClient(checked);
      if (checked) setLongTermClient(false);
    }}
  />
  New client (under 6 months)
</label>

<label style={checkboxRow}>
  <input
    type="checkbox"
    checked={longTermClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setLongTermClient(checked);
      if (checked) setNewClient(false);
    }}
  />
  Long-term client (12+ months)
</label>


        {/* ROUTINE CLEANING SERVICES */}
        <h3 style={sectionHeaderPurple}>Routine Cleaning Tasks</h3>

        {Object.keys(services).map((key) => (
          <Checkbox
            key={key}
            label={key.replace(/([A-Z])/g, " $1")}
            value={services[key]}
            setValue={() => toggleService(key)}
          />
        ))}

        {/* PRICING (LOCKED) */}
        <h3 style={sectionHeaderOrange}>Pricing (Locked)</h3>

      

        <label style={labelBold}>Average Job Price ($)</label>
        <input style={{ ...input, background: "#eee" }} disabled value={avgJobPrice} />

        <label style={labelBold}>Sale Price ($)</label>
        <input style={{ ...input, background: "#eee" }} disabled value={salePrice} />

        <button type="submit" style={button}>
          Save Changes
        </button>
      </form>
    </div>
  );
}

// ================================
// REUSABLE CHECKBOX (MATCH POST)
function Checkbox({ label, value, setValue }) {
  return (
    <label style={checkboxRow}>
      <input type="checkbox" checked={!!value} onChange={(e) => setValue(e.target.checked)} />
      {label}
    </label>
  );
}

// ================================
// STYLES (MATCH POST)
const container = {
  maxWidth: "650px",
  margin: "40px auto",
  background: "#fff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
};

const pageHeader = {
  textAlign: "center",
  marginBottom: "25px",
  color: "#2e7d32",
  fontWeight: "bold",
};

const form = { display: "flex", flexDirection: "column", gap: "20px" };
const input = { padding: "10px", borderRadius: "6px", border: "1px solid #ccc" };
const labelBold = { fontWeight: "bold" };

const checkboxRow = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  fontSize: "0.95rem",
};

const sectionHeader = { borderBottom: "2px solid #4CAF50", paddingBottom: "6px" };
const sectionHeaderBlue = { borderBottom: "2px solid #1976D2", paddingBottom: "6px" };
const sectionHeaderPurple = { borderBottom: "2px solid #9C27B0", paddingBottom: "6px" };
const sectionHeaderOrange = { borderBottom: "2px solid #FF9800", paddingBottom: "6px" };

const button = {
  padding: "14px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
};

export default EditCleaningListings;
